import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcForwardIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes, Loader } from '@gem/ui-kit';

import { useForwardMessage } from 'APP/main/ChatView/hooks/useForwardMessage/useForwardMessage';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import styles from './ForwardMessage.styles.m.css';

type TForwardMessageTheme = '1' | '2';

interface IForwardMessageProps {
  className?: string;
  theme?: TForwardMessageTheme;
  message: ChatMessage;
}

export const ForwardMessage: FC<IForwardMessageProps> = observer(
  ({ message, className, theme = '1' }) => {
    const { t } = useTranslation();
    const presenter = useForwardMessage(message);

    return (
      <div className={classNames(styles.container, styles[`theme-${theme}`], className)}>
        <IconView
          Icon={IcForwardIcon}
          size={IconViewSizes.Small}
          className={styles.icon}
        />
        <span className={styles.title}>{t('message_forwarded_from')}</span>

        <button
          className={styles.senderName}
          title={presenter.avatarTitle}
          onClick={presenter.onClick}
        >
          {presenter.avatarTitle}
          {presenter.isLoading && (
            <Loader
              className={styles.loader}
              color="current"
            />
          )}
        </button>
      </div>
    );
  }
);
